/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveySubmissionWithResponses = {
    properties: {
        submissionId: {
    type: 'number',
},
        staffId: {
    type: 'number',
},
        staffName: {
    type: 'string',
},
        staffDepartmentID: {
    type: 'number',
},
        staffDepartment: {
    type: 'string',
},
        StaffTitleID: {
    type: 'number',
},
        staffTitle: {
    type: 'string',
},
        createdAt: {
    type: 'string',
    format: 'date-time',
},
        updatedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
        responses: {
    type: 'array',
    contains: {
        type: 'StaffSurveyResponseWithDetails',
    },
},
    },
};